export default __webpack_public_path__ + "static/media/alt-logo-1.010fe0d9.png";